import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            inventoryApiUrl: process.env.VUE_APP_INVENTORY_API_URL
        }
    },
    methods: {
        async getPresign(fileName, lastModified) {
            const payload = {
                fileName: fileName,
                lastModified: lastModified,
            };

            const {data} = await apiClient.post(`${this.inventoryApiUrl}/presign`, payload);

            return data;
        },
        async uploadFile(presignedPost, file) {
            const formData = new FormData();

            Object.entries(presignedPost.fields).forEach(([k, v]) => {
                formData.append(k, v);
            });

            formData.append("file", file);

            return await apiClient.post(presignedPost.url, formData);
        },
        async linkMedia(media) {
            const payload = {
                media: media,
            };

            const {data} = await apiClient.post(`${this.inventoryApiUrl}/media-link`, payload);

            return data;
        }
    }
};